import { unitOfTime } from 'moment';
import { addUnits, dateFormatZurich } from './datetime';

export const AdvisorySystem = {
    ImpaQt: 0,
    eAdvise: 1,
    PensionPlanner: 2,
    DFS: 3,
};

export const ValidityPeriodsByAdvisorySystem: {
    [p: number]: { amount: number; units: unitOfTime.DurationConstructor };
} = {
    [AdvisorySystem.ImpaQt]: {
        amount: 3,
        units: 'months',
    },
    [AdvisorySystem.eAdvise]: {
        amount: 3,
        units: 'years',
    },
    [AdvisorySystem.PensionPlanner]: {
        amount: 3,
        units: 'years',
    },
    [AdvisorySystem.DFS]: {
        amount: 3,
        units: 'months',
    },
};

export const getPropertyValueMinusMortgage = (val) => {
    if (val && Array.isArray(val) && val?.length) {
        const value = val?.reduce(
            (accumulator, currentValue) => accumulator + +currentValue.value || 0,
            0,
        );
        const mortgage = val?.reduce(
            (accumulator, currentValue) => accumulator + +currentValue.mortgage || 0,
            0,
        );

        return value - mortgage;
    }

    return null;
};

export const getAdvisoryValidTillDate = ({ advisoryDate, system }) => addUnits(
    advisoryDate,
    ValidityPeriodsByAdvisorySystem[system].amount,
    ValidityPeriodsByAdvisorySystem[system].units,
    dateFormatZurich,
);
